import { Box, Divider } from "@mui/material";
import React, { useEffect, useState } from "react";
import ContactListItem from "./ContactListItem";
import { infoSection } from "./styles";
import {assertArray} from "core/validation";

const AddContactList = (props) => {
    const classes = infoSection();

    const { disabled, values, setFieldValue, commonProps, errors, touched, xs, lg, onChangePhone } = props;
    const [counter, setCounter] = useState(values?.addressList?.length);

    useEffect(() => {
        if (values.addressList) {
            setFieldValue("addressList", [
                ...values.addressList.map((address, index) => {
                    return { ...address, index: index };
                }),
            ]);
            setCounter(values.addressList.length);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function addAddress() {
        setCounter(counter + 1);
        const newAddressList = { index: counter, id: null, phone1: "", phone2: "", email: "" };
        setFieldValue("addressList", [...values.addressList, newAddressList]);
    }

    function removeAddress(index) {
        setFieldValue(
            "addressList",
            values.addressList.filter((address) => address.index !== index)
        );
    }





    const addressList = assertArray(values.addressList) ? values.addressList : [];
    const length = addressList.length;
    if (length === 0 && counter === 0) {
        addAddress();
    }
    const listComponent = addressList.map((address, index) => {
        const addDivider = length >= 2 && index >= 0 && index < length - 1;
        return (
            <>
                <ContactListItem
                    disabled={disabled}
                    handleRemove={() => removeAddress(address.index)}
                    values={address}
                    key={address.index}
                    addAddress={addAddress}
                    index={index}
                    listLength={length}
                    commonProps={commonProps}
                    onChangePhone={onChangePhone}
                    setFieldValue={setFieldValue}
                    isLastItem={length > 0 ? length - 1 === index : true}
                    errors={errors && errors[index] ? errors[index] : null}
                    touched={touched && touched[index] ? touched[index] : null}
                    xs={xs}
                    lg={lg}
                />
                {addDivider && <Divider style={{ marginTop: 5, marginBottom: 5 }} />}
            </>
        );
    });

    return <Box className={[classes.contactListContainer, classes.scroll]}>{listComponent}</Box>;
};

export default AddContactList;
